import styled from 'styled-components';

import { colors } from 'theme/theme';

export const CmsFormBuilderBlockContainer = styled.div<{
  $disabled?: boolean;
  $isTabbing?: boolean;
}>`
  ${(props) =>
    props.$disabled &&
    `
  pointer-events: none;
`}
  && {
    input,
    select {
      border: none !important;
    }
    .checkmark-container {
      box-shadow: none !important;
      background: white !important;
      svg {
        * {
          stroke: ${colors.brandBlue};
        }
      }
    }
    input:not([type='checkbox']),
    select {
      height: 50px;
      ${(props) =>
        props.$isTabbing
          ? `box-shadow: 0 0 0 6px white inset, -16px 0 0 0 white inset,
                16px 0 0 0 white inset, 0 -5px ${colors.brandBlue} inset;`
          : ''}
      &:focus {
        box-shadow: ${(props) =>
          !props.$isTabbing
            ? `0 2px 5px 2px rgba(0, 0, 0, 0.3)`
            : `0 2px 5px 2px rgba(0, 0, 0, 0.3),
                0 0 0 6px white inset, -16px 0 0 0 white inset,
                16px 0 0 0 white inset, 0 -8px ${colors.brandBlue} inset`};
      }
    }
    label {
      color: white;
      & + *:not([type='checkbox']) {
        margin-top: 0;
      }
    }
  }
`;
